module.exports = __webpack_public_path__ + "media/images/meetAnna-child-191414237475fcfb5d7e1a15dcbd035e.svg";